import { requests } from "../../utils/api/api.service";
import { EXTERNAL_INCIDENTS_URL, EXTERNAL_INCIDENT_ACTIVITIES_URL } from "../../utils/api/endpoints";
import { IIncident, IIncidentActivity } from "../../shared/interfaces/incident/IIncident";

export const ExternalIncidentService = {
  getAll: (): Promise<IIncident[] | { data: IIncident[] }> =>
    requests.get(EXTERNAL_INCIDENTS_URL),
  getSingle: (id: number): Promise<{ data: IIncident }> =>
    requests.get(`${EXTERNAL_INCIDENTS_URL}/${id}`),
  getActivities: (incidentId: number): Promise<{ data: IIncidentActivity[] }> =>
    requests.get(`${EXTERNAL_INCIDENT_ACTIVITIES_URL}/incident/${incidentId}`),
};
